export default function ComparisonTable() {
  const rows = [
    { feature: 'Gotowe listy produktów', kakobuy: true, normal: false },
    { feature: 'Kategorie tematyczne', kakobuy: true, normal: false },
    { feature: 'Oszczędność czasu', kakobuy: true, normal: false },
    { feature: 'Regularne aktualizacje', kakobuy: true, normal: false },
    { feature: 'Polska wersja językowa', kakobuy: true, normal: false },
    { feature: 'Poradniki zakupowe', kakobuy: true, normal: false },
    { feature: 'Szybkie wyszukiwanie', kakobuy: true, normal: true },
    { feature: 'Dostęp do produktów', kakobuy: true, normal: true },
  ];

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Kakobuy Spreadsheet vs Normalne Wyszukiwanie
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Zobacz, dlaczego <strong>Kakobuy Spreadsheet</strong> to najlepszy sposób na znalezienie produktów z Chin.
          </p>
        </div>

        {/* Table */}
        <div className="rounded-xl border border-background-200/70 overflow-hidden">
          {/* Table Header */}
          <div className="grid grid-cols-3 bg-background-100 border-b border-background-200/70">
            <div className="px-4 md:px-6 py-3 md:py-4">
              <span className="text-xs md:text-sm font-semibold text-foreground-800">Funkcja</span>
            </div>
            <div className="px-4 md:px-6 py-3 md:py-4 text-center bg-primary-50/50">
              <span className="text-xs md:text-sm font-semibold text-primary-700">Kakobuy Spreadsheet</span>
            </div>
            <div className="px-4 md:px-6 py-3 md:py-4 text-center">
              <span className="text-xs md:text-sm font-semibold text-foreground-500">Normalne wyszukiwanie</span>
            </div>
          </div>

          {/* Table Body */}
          <div className="divide-y divide-background-200/50">
            {rows.map((row, idx) => (
              <div
                key={row.feature}
                className={`grid grid-cols-3 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}
              >
                <div className="px-4 md:px-6 py-3 md:py-3.5">
                  <span className="text-xs md:text-sm text-foreground-700">{row.feature}</span>
                </div>
                <div className="px-4 md:px-6 py-3 md:py-3.5 text-center bg-primary-50/30">
                  {row.kakobuy ? (
                    <div className="w-6 h-6 flex items-center justify-center mx-auto">
                      <i className="ri-check-line text-secondary-500 text-lg"></i>
                    </div>
                  ) : (
                    <div className="w-6 h-6 flex items-center justify-center mx-auto">
                      <i className="ri-close-line text-foreground-400 text-lg"></i>
                    </div>
                  )}
                </div>
                <div className="px-4 md:px-6 py-3 md:py-3.5 text-center">
                  {row.normal ? (
                    <div className="w-6 h-6 flex items-center justify-center mx-auto">
                      <i className="ri-check-line text-foreground-400 text-lg"></i>
                    </div>
                  ) : (
                    <div className="w-6 h-6 flex items-center justify-center mx-auto">
                      <i className="ri-close-line text-foreground-300 text-lg"></i>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}